var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDVstEthIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5496_3563)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_radial_5496_3563)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint1_radial_5496_3563)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.1625 58.6239C-21.9281 60.7649 -21.9485 64.2354 -18.207 66.3752L32.5155 95.3944C36.2571 97.5354 42.344 97.5354 46.1096 95.3944L97.1625 66.3764C100.928 64.2354 100.949 60.7649 97.207 58.6251L46.4845 29.6059C42.7429 27.4649 36.656 27.4649 32.8904 29.6059L-18.1625 58.6239Z",
    fill: "url(#paint2_radial_5496_3563)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.1625 58.6239C-21.9281 60.7649 -21.9485 64.2354 -18.207 66.3752L32.5155 95.3944C36.2571 97.5354 42.344 97.5354 46.1096 95.3944L97.1625 66.3764C100.928 64.2354 100.949 60.7649 97.207 58.6251L46.4845 29.6059C42.7429 27.4649 36.656 27.4649 32.8904 29.6059L-18.1625 58.6239Z",
    fill: "url(#paint3_radial_5496_3563)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M95.2563 8.2639C98.8974 6.18497 98.9172 2.81504 95.2993 0.737264L46.2536 -27.4408C42.6357 -29.5197 36.75 -29.5197 33.1089 -27.4408L-16.2563 0.7361C-19.8974 2.81503 -19.9172 6.18495 -16.2993 8.26273L32.7464 36.4408C36.3643 38.5197 42.25 38.5197 45.8911 36.4408L95.2563 8.2639Z",
    fill: "url(#paint4_radial_5496_3563)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M95.2563 8.2639C98.8974 6.18497 98.9172 2.81504 95.2993 0.737264L46.2536 -27.4408C42.6357 -29.5197 36.75 -29.5197 33.1089 -27.4408L-16.2563 0.7361C-19.8974 2.81503 -19.9172 6.18495 -16.2993 8.26273L32.7464 36.4408C36.3643 38.5197 42.25 38.5197 45.8911 36.4408L95.2563 8.2639Z",
    fill: "url(#paint5_radial_5496_3563)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M56.099 35.1681L56.5505 35.8553C61.6418 43.6062 60.5047 53.7571 53.8167 60.2604C49.8821 64.0863 44.7254 65.9995 39.5685 66C39.5685 66 39.5685 66 56.099 35.1681Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.5667 44.5387L56.0972 35.1681C39.5667 66 39.5667 66 39.5667 66C39.5667 59.285 39.5667 51.5906 39.5667 44.5387Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0206 35.1681L22.5692 35.8553C17.4778 43.6062 18.6149 53.7571 25.3029 60.2604C29.2375 64.0863 34.3942 65.9995 39.5511 66C39.5511 66 39.5511 66 23.0206 35.1681Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M39.5461 44.5387L23.0156 35.1681C39.5461 66 39.5461 66 39.5461 66C39.5461 59.285 39.5461 51.5906 39.5461 44.5387Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.5732 23.605V39.7667L53.8124 31.6911L39.5732 23.605Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M39.5688 23.605L25.3193 31.6909L39.5688 39.7667V23.605Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5688 10.0127L25.3193 31.6958L39.5688 23.5871V10.0127Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M39.5732 23.585L53.8233 31.6939L39.5732 10V23.585Z",
    fill: "#00A3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5496_3563",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.3795 51.4815) rotate(-57.1946) scale(22.796 22.7273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5496_3563",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5 0.999999) rotate(104.763) scale(40.3371)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00395421,
    stopColor: "#FF955A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B469",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5496_3563",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 48.5001) rotate(106.574) scale(43.8207 36.7265)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.508316,
    stopColor: "#FF8A00",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825401,
    stopColor: "#FFA944",
    stopOpacity: 0.677974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9051"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5496_3563",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43 28.0001) rotate(103.928) scale(64.3933 53.9687)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.508316,
    stopColor: "#FF8A00",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825401,
    stopColor: "#FFA944",
    stopOpacity: 0.677974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9051"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5496_3563",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5 35.5) rotate(-85.2921) scale(42.6439 53.7004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.407652,
    stopColor: "#FF8A00",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740114,
    stopColor: "#FFA944",
    stopOpacity: 0.677974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9051"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5496_3563",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5 35.5) rotate(-85.2921) scale(42.6439 53.7004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.407652,
    stopColor: "#FF8A00",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740114,
    stopColor: "#FFA944",
    stopOpacity: 0.677974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9051"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5496_3563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDVstEthIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DVstETHIcon.52f22f10c3c7a86b592861080232c358.svg";